import { render, staticRenderFns } from "./enterCommunityList.vue?vue&type=template&id=610518ce&scoped=true"
import script from "./enterCommunityList.vue?vue&type=script&lang=js"
export * from "./enterCommunityList.vue?vue&type=script&lang=js"
import style0 from "./enterCommunityList.vue?vue&type=style&index=0&id=610518ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610518ce",
  null
  
)

export default component.exports